import { createContext, useContext } from "react";

export type DashboardVariant = "v1" | "v2";

export const DashboardVariantContext = createContext<DashboardVariant>("v1");

export const useIsDashboardV2 = () =>
	useContext(DashboardVariantContext) === "v2";
